/**
 * Cursor-Helfer fuer Implementierungen, die im Speicher arbeiten.
 * Die echte Datenbank nutzt spaeter Keyset-Pagination ueber (sortKey, id);
 * die Signatur nach aussen bleibt identisch.
 */
export function encodeCursor(offset) {
    return Buffer.from(`o:${offset}`, 'utf8').toString('base64url');
}
export function decodeCursor(cursor) {
    if (!cursor)
        return 0;
    try {
        const raw = Buffer.from(cursor, 'base64url').toString('utf8');
        const value = Number.parseInt(raw.replace('o:', ''), 10);
        return Number.isFinite(value) && value >= 0 ? value : 0;
    }
    catch {
        return 0;
    }
}
export function paginate(items, cursor, limit) {
    const offset = decodeCursor(cursor);
    const slice = items.slice(offset, offset + limit);
    const nextOffset = offset + slice.length;
    const hasMore = nextOffset < items.length;
    return {
        items: slice,
        nextCursor: hasMore ? encodeCursor(nextOffset) : null,
        hasMore,
    };
}
//# sourceMappingURL=cursor.js.map